<template>
    <div class="home-banner-user">
        <div class="user-inner">
            <div v-if="authUser.user === null" class="inner-guest">
                <span class="gradient-green">SIGN IN TO START</span>
                <AuthButton />
            </div>
            <div v-else class="inner-auth" v-bind:class="[
                'auth-' + homeGetLevelColor
            ]">
                <span class="gradient-green">BLOXIFY LAUNCHED VERSION 1.0</span> 
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import AuthButton from '@/components/AuthButton';
    import AvatarImage from '@/components/AvatarImage';

    export default {
        name: 'HomeBannerUser',
        components: {
            AuthButton,
            AvatarImage
        },
        computed: {
            ...mapGetters([
                'authUser'
            ]),
            homeGetLevel() {
                let level = Math.floor(Math.pow(this.authUser.user.xp / 1000 / 100, 1 / 3));
                return level >= 100 ? 100 : level; 
            },
            homeGetLevelColor() {
                let color = '';

                if(this.homeGetLevel >= 2 && this.homeGetLevel < 26) { color = 'blue'; }
                else if(this.homeGetLevel >= 26 && this.homeGetLevel < 51) { color = 'green'; }
                else if(this.homeGetLevel >= 51 && this.homeGetLevel < 76) { color = 'orange'; }
                else if(this.homeGetLevel >= 76 && this.homeGetLevel < 100) { color = 'red'; }
                else if(this.homeGetLevel >= 100) { color = 'purple'; }

                return color;
            },
            homeGetLevelBet() {
                return this.homeGetLevel >= 100 ? 2970100 : (Math.pow(this.homeGetLevel + 1, 3) - Math.pow(this.homeGetLevel, 3)) * 100;
            },
            homeGetLevelProgress() {
                return Math.floor((this.homeGetLevel >= 100 ? 2970100 * 1000 : this.authUser.user.xp - (Math.pow(this.homeGetLevel, 3) * 100 * 1000)) / 10) / 100;
            }
        }
    }
</script>

<style scoped>
/* NOTE: All indentation in the CSS is removed to prevent SyntaxErrors. */
.home-banner-user {
width: calc(150% - 15px);
height: 175px;
position: relative;
margin-right: 30px;
padding: 1px;
z-index: 1;
}

.home-banner-user::before {
content: '';
width: 100%;
height: 100%;
position: absolute;
top: 0;
left: 0;
border-radius: 15px;
background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #00a2ffff 100%);
z-index: -1;
}

.home-banner-user::after {
content: '';
width: calc(100% - 2px);
height: calc(100% - 2px);
position: absolute;
top: 1px;
left: 1px;
border-radius: 15px;
background-color: #031d32;
z-index: -1;
}

.home-banner-user .user-inner {
width: 100%;
height: 100%;
position: relative;
padding: 22px 35px 22px 35px; 
border-radius: 15px;
/* FIXED: Solid background color instead of gradient */
background: #062641; 
z-index: 1;
}

/* REMOVED .home-banner-user .user-inner img:nth-of-type(1) CSS */

.home-banner-user .user-inner img:nth-of-type(2) {
height: 205px;
position: absolute;
bottom: -23px;
right: -15px;
transform: scaleX(-1);
z-index: -1;
}

.home-banner-user .inner-guest,
.home-banner-user .inner-auth {
height: 100%;
display: flex;
flex-direction: column;
justify-content: center; 
align-items: center; 
z-index: 1;
}

.home-banner-user .inner-guest {
justify-content: center;
}

.home-banner-user .inner-guest span.gradient-green,
.home-banner-user .inner-auth span.gradient-green {
font-size: 50px;
font-weight: 1200;
text-shadow: 0px 0px 25px rgba(0, 225, 255, 0.55);
text-align: center;
}

.home-banner-user .inner-guest button.auth-button {
margin-top: 15px;
}

@media only screen and (max-width: 900px) {
.home-banner-user {
width: 100%;
margin-right: 0;
}
}

@media only screen and (max-width: 600px) {
.home-banner-user .user-inner {
padding: 22px 20px;
}
.home-banner-user .user-inner img:nth-of-type(2) {
display: none;
}
}
</style>